import React from 'react';
import Popover from '@material-ui/core/Popover';
import PropTypes from 'prop-types';
import { PopoverStyle } from '../../../theme/AllocateBaseTheme';
import TreatmentInstanceDialogOpener from '../../../containers/DailyPlanning/TreatmentInstanceDialogOpener/TreatmentInstanceDialogOpenerContainer';

class TreatmentInstancePopover extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.treatmentInstanceId !== nextProps.treatmentInstanceId || this.state.isOpen !== nextState.isOpen;
  }

  handleTouchTap = event => {
    event.preventDefault();
    event.stopPropagation();

    this.setState({
      isOpen: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      isOpen: false,
    });
  };

  render() {
    const { children, id, treatmentId, treatmentInstanceId, occurrence } = this.props;
    const { isOpen, anchorEl } = this.state;

    return (
      <span className="treatment-actions-icons">
        <i role="button" tabIndex="-1" className="allocateIcons info" onClick={this.handleTouchTap}>
          info
        </i>
        <Popover
          open={isOpen}
          anchorEl={anchorEl}
          style={PopoverStyle}
          onClose={this.handleRequestClose}
          className="popover-dark-theme"
        >
          {children}
          {treatmentInstanceId && treatmentId && occurrence && (
            <TreatmentInstanceDialogOpener
              id={id}
              onOpen={this.handleRequestClose}
              treatmentId={treatmentId}
              treatmentInstanceId={treatmentInstanceId}
              occurrence={occurrence}
            />
          )}
        </Popover>
      </span>
    );
  }
}

TreatmentInstancePopover.propTypes = {
  id: PropTypes.string.isRequired,
  treatmentId: PropTypes.number.isRequired,
  treatmentInstanceId: PropTypes.number.isRequired,
  occurrence: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default TreatmentInstancePopover;
